"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardLinkIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CardLinkIcon = _ref => {
  let {
    iconClass,
    external
  } = _ref;
  if (external && external === true) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${iconClass} external-arrow`
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      role: "img",
      "aria-label": "external link icon"
    }, /*#__PURE__*/_react.default.createElement("path", {
      className: "arrow",
      d: "M17,12a1,1,0,0,0-1,1v5H2V4H7A1,1,0,0,0,7,2H1A1,1,0,0,0,0,3V19a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V13A1,1,0,0,0,17,12Z",
      fill: "#252A2E"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: "arrow",
      d: "M19,0H12a1,1,0,0,0,0,2h4.59l-8.3,8.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L18,3.41V8a1,1,0,0,0,2,0V1A1,1,0,0,0,19,0Z",
      fill: "#252A2E"
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: iconClass
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      role: "img",
      "aria-label": "internal link icon"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, /*#__PURE__*/_react.default.createElement("path", {
      className: "arrow",
      d: "M19,0H1A1,1,0,0,0,0,1V19a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V1A1,1,0,0,0,19,0ZM18,18H2V2H18Z",
      fill: "#252A2E"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: "arrow",
      d: "M5,11h7.59L9.34,14.24a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-4.95a1,1,0,0,0,0-1.42l-5-4.95A1,1,0,0,0,9.34,5.76L12.59,9H5a1,1,0,0,0,0,2Z",
      fill: "#252A2E"
    })))));
  }
};
exports.CardLinkIcon = CardLinkIcon;